import React from "react";
import { toggle } from "../../../util/common";
import { IRecentInquiries } from "../../../store/credit/types";
import CreditHistoryRecentInquiriesSingle from "./CreditHistoryRecentInquiriesSingle";
import { useTranslation } from "react-i18next";

interface IProps {
    data?: IRecentInquiries[];
}

const CreditHistoryRecentInquiries: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang } = useTranslation();
    let transUnionList = null;
    let equifaxList = null;
    let experianList = null;
    if (props.data != null) {
        transUnionList = props.data.filter((it) => it.bureau === "TransUnion");
        equifaxList = props.data.filter((it) => it.bureau === "Equifax");
        experianList = props.data.filter((it) => it.bureau === "Experian");
    }

    return (
        <React.Fragment>
            <div className="drawer-container">
                <div className="drawer-header">
                    <button
                        aria-expanded="false"
                        className="btn-default btn-toggle btn-drawer"
                        id="btn-recent-inquiries"
                        onClick={() => toggle("recent-inquiries", "btn-recent-inquiries")}
                    >
                        <span className="btn-toggle-status sr-only">Show</span>
                        <span className="btn-text">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.recentInquiriesSection.title")}</span>
                    </button>
                </div>

                <div className="drawer-content" id="recent-inquiries" style={{ display: "none" }}>
                    {transUnionList != null && transUnionList.length > 0 ? <CreditHistoryRecentInquiriesSingle data={transUnionList} /> : ""}

                    {equifaxList != null && equifaxList.length > 0 ? <CreditHistoryRecentInquiriesSingle data={equifaxList} /> : ""}

                    {experianList != null && experianList.length > 0 ? <CreditHistoryRecentInquiriesSingle data={experianList} /> : ""}
                </div>
            </div>
        </React.Fragment>
    );
};

export default CreditHistoryRecentInquiries;
